<template>
  <div class="immo-support-enum">
    <component v-for="icon in icons" :key="icon" :is="icon"></component>
  </div>
</template>
<script>
export default {
  name: 'ImmoSupportEnum',
  props: {
    scope: Object,
  },
  computed: {
    immoSupport() {
      return this.$store.state.immoSupport
    },
    icons() {
      var ret = []
      var val = this.$getPropValue(this.scope.row, this.scope.column.property)
      if (typeof val == 'string') {
        for (var i = 0; i < val.length; i++) {
          var icon = this.getIcon(val[i])
          if (icon) {
            ret.push(icon)
          }
        }
      }
      return ret
    },
  },
  methods: {
    getIcon(val) {
      for (var item of this.immoSupport) {
        if (item.value == val) {
          return item.icon
        }
      }
      return null
    },
  },
}
</script>
<style lang="less">
.immo-support-enum {
  svg {
    vertical-align: middle;
    margin-right: 2px;
  }
}
</style>